import { NOOP } from 'constants/actions';
import PropTypes from 'prop-types';
import { useTranslations } from 'utils/translations/useTranslations';

import './CloseModalConfirmation.scss';
import { Heading } from 'components/ui/Heading/Heading';

export function CloseModalConfirmation({
  onConfirm = NOOP,
  onCancel = NOOP,
  title = 'checkout.cancel.title',
  description = 'checkout.cancel.description',
}) {
  const i18n = useTranslations();
  return (
    <div
      className="CloseModalConfirmation drawer:shadow-none drawer:rounded-none drawer:p-0"
      role="alertdialog"
      aria-labelledby="CloseModalConfirmation--title"
      aria-describedby="CloseModalConfirmation--desc"
    >
      <Heading
        as="h2"
        size="large"
        className="fontWeight-semiBold"
        id="CloseModalConfirmation--title"
      >
        {i18n.t(title)}
      </Heading>
      <div>
        <p className="fontSize-sm" id="CloseModalConfirmation--desc">
          {i18n.t(description)}
        </p>
      </div>
      <div className="CloseModalConfirmation-actions drawer:flex drawer:flex-col drawer:gap-3">
        <button
          onClick={onCancel}
          className="Button cancelCloseModalButton drawer:w-full"
          data-testid="cancelCloseModal"
        >
          {i18n.t('checkout.LRS.previousTransfers.question.no')}
        </button>
        <button
          onClick={onConfirm}
          className="Button Button--primary marginLeft-md drawer:w-full drawer:!ml-0"
          data-testid="confirmCloseModal"
        >
          {i18n.t('checkout.LRS.previousTransfers.question.yes')}
        </button>
      </div>
    </div>
  );
}

CloseModalConfirmation.propTypes = {
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
};
